import {useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import deserializeDates from './middlewares/luxonDateTimeMiddleware/deserializeDates';
import type {CLDispatch, RootState} from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useCLDispatch = useDispatch.withTypes<CLDispatch>();

export function useCLReduxSelector<RT>(selectFn: (state: RootState) => RT): RT {
  const typedUseSelector = useSelector.withTypes<RootState>();
  const value = typedUseSelector(selectFn);
  const deserializedValue = useMemo(() => deserializeDates(value), [value]);

  return deserializedValue as RT;
}
